import axios, { AxiosInstance } from 'axios';
import { getExhibitionHeader } from "../utils/exhibitionContext";

export interface Identification {
  id: number;
  name: string;
  length: number;
  requires_country: boolean;
}

const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000",
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Dynamically attach token before each request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    Object.assign(config.headers, getExhibitionHeader());
    }
    return config;
  },
  (error) => Promise.reject(error)
);

interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  total_pages: number;
  current_page: number;
  page_size: number;
  results: T[];
}

const IdentificationService = {
  getAll: async (): Promise<PaginatedResponse<Identification>> => {
    const response = await api.get('/api/accounts/id-document-types/');
    return response.data;
  },

  async create(data: Omit<Identification, 'id'>): Promise<Identification> {
    const response = await api.post('/api/accounts/id-document-types/create/', data);
    return response.data;
  },

  async update(id: number, data: Omit<Identification, 'id'>): Promise<Identification> {
    const response = await api.put(`/api/accounts/id-document-types/${id}/update/`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/api/accounts/id-document-types/${id}/delete/`);
  },
};

export default IdentificationService;
